// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TwNl","index":"styles_index__16eUr"};